import React, { Component } from "react";
import ReactTable from "react-table";
import { Link } from "react-router-dom";
import moment from "moment";
import ExamModule from "..";

const PAGE_SIZE = 100;

export default class ExamListing extends Component<any, any> {
  private fetchTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(props: any) {
    super(props);

    this.state = {
      data: [],
      pages: 1,
      loading: true,
      page: 0,
      search: "",
    };
    this.onFetchData = this.onFetchData.bind(this);
    this._handleFetchExams = this._handleFetchExams.bind(this);
  }

  convertExamToTableFriendlyFormat = (exam: any) => {
    return {
      ...exam,
      createdAt: moment(exam.createdAt).format("ll"),
    };
  };

  _handleFetchExams = (page: number = 0, search: string = "") => {
    const currentTab = this.props.currentTab;
    const module: ExamModule = this.props.module;
    this.setState({ loading: true });
    module.services
      .getAllExam(currentTab === "all" ? null : currentTab, {
        page,
        limit: PAGE_SIZE,
        search,
      })
      .then((response: any) => {
        const exams = response?.exams || [];
        this.setState({
          data: exams.map((exam: any) =>
            this.convertExamToTableFriendlyFormat(exam)
          ),
          pages: response?.pages || 1,
          page: response?.page ?? page,
          search,
          loading: false,
        });
      })
      .catch((e) => {
        this.setState({ loading: false });
        this.props.module.showError(
          "Fetching course failed",
          e.message ? e.message : "Network error",
          true
        );
      });
  };

  onFetchData(state: any) {
    const titleFilter = (state.filtered || []).find(
      (f: any) => f.id === "title"
    );
    const search = titleFilter?.value ? String(titleFilter.value).trim() : "";
    const searchChanged = search !== this.state.search;
    const page = searchChanged ? 0 : state.page || 0;

    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }

    this.fetchTimeout = setTimeout(
      () => {
        this._handleFetchExams(page, search);
      },
      searchChanged && search ? 400 : 0
    );
  }

  componentWillUnmount() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }
  }

  render() {
    const { data, pages, loading } = this.state;
    return (
      <>
        <div className="">
          <div className="pt-3">
            <ReactTable
              manual
              defaultPageSize={PAGE_SIZE}
              pageSizeOptions={[PAGE_SIZE]}
              page={this.state.page}
              pages={pages}
              minRows={3}
              data={data}
              loading={loading}
              onFetchData={this.onFetchData}
              columns={[
                {
                  Header: "Exams",
                  accessor: "title",
                  filterable: true,
                  Cell: (row) => (
                    <Link
                      className="text-primary"
                      rel="noopener noreferrer"
                      to={`/admin/exams/editor/${row.original._id}`}
                    >
                      {row.value}
                    </Link>
                  ),
                },
                {
                  Header: "Status",
                  accessor: "isPublished",
                  filterable: false,
                  Cell: (row) => {
                    const publishMessage: string = row.original.publishMessage;
                    const hasMessage: boolean =
                      publishMessage !== null && publishMessage !== "";
                    return (
                      <span
                        className={`${
                          row.value === true
                            ? "text-success"
                            : `${
                                hasMessage ? "text-warning" : "text-danger"
                              } font-weight-bold`
                        }`}
                      >
                        {row.value === true
                          ? "Published"
                          : hasMessage === true
                          ? publishMessage
                          : "Unpublished"}
                      </span>
                    );
                  },
                },
                {
                  Header: "Date Created",
                  accessor: "createdAt",
                  filterable: false,
                },
                {
                  Header: "Template Type",
                  accessor: "templateId",
                  className: "lh-110 text-capitalize",
                  filterable: false,
                },
              ]}
            />
          </div>
        </div>
      </>
    );
  }
}
